import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { format, startOfMonth, sub } from 'date-fns';
import isEmpty from 'lodash.isempty';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import NavButton from '../../../components/NavButton';
import { useUserStore } from '../../../components/userStore';
import { formatBirthDate } from '../../../components/util';
import constants from '../../../constants';

const USDollar = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
});

const CURR_YEAR = new Date().getFullYear();

const Invoicing = () => {
	const { user } = useUserStore();
	const [year, setYear] = useState(new Date().getFullYear());
	const [month, setMonth] = useState(new Date().getMonth() + 1);
	// const invoiceableAgenciesQuery = useQuery({
	// 	queryKey: ['invoiceable-agencies', user.coord_agency.id],
	// 	queryFn: async () => {
	// 		const { data } = await axios.get(
	// 			`/coord_agencies/${user.coord_agency.id}/invoiceable-agencies`,
	// 		);
	// 		return data;
	// 	},
	// });
	// const invoiceableReferralsQuery = useQuery({
	// 	queryKey: ['invoiceable-referrals', user.coord_agency.id, year, month],
	// 	queryFn: async () => {
	// 		const { data } = await axios.get(
	// 			`/coord_agencies/${user.coord_agency.id}/invoiceable-referrals`,
	// 			{
	// 				params: {
	// 					options: {
	// 						year,
	// 						month,
	// 					},
	// 				},
	// 			},
	// 		);
	// 		return data;
	// 	},
	// 	enabled: invoiceableAgenciesQuery.isFetched,
	// });
	const lineItemsQuery = useQuery({
		queryKey: ['ilos-line-items', user.coord_agency.id, year, month],
		queryFn: async () => {
			const { data } = await axios.get(
				`/coord_agencies/${user.coord_agency.id}/ilos-line-items`,
				{
					params: {
						options: {
							year,
							month: month - 1,
						},
					},
				},
			);
			return data;
		},
	});
	const lineItemMutation = useMutation({
		mutationFn: async (lineItem) => {
			const { data } = await axios.post(
				`/requests/${lineItem.request_id}/fulfill-line-item/${lineItem.id}`,
				{ status: lineItem.status },
			);
			return data;
		},
		onSuccess: () => {
			lineItemsQuery.refetch();
		},
		onError: (/*error*/) => {
			// console.error('Error fulfilling line item:', error);
		},
	});

	const handleNextMonth = () => {
		const nextMonth = new Date(year, month, 1);
		setYear(nextMonth.getFullYear());
		setMonth(nextMonth.getMonth() + 1);
	};

	const handlePreviousMonth = () => {
		const previousMonth = new Date(year, month, 1);
		previousMonth.setMonth(previousMonth.getMonth() - 1);
		setYear(previousMonth.getFullYear());
		setMonth(previousMonth.getMonth());
	};

	// const getServiceNameFromTaxonomyID = (taxonomyID, serviceTaxonomies) => {
	// 	const taxonomy = serviceTaxonomies.find(
	// 		(service) => service.taxonomy_id === taxonomyID,
	// 	);
	// 	if (taxonomy) {
	// 		return taxonomy.taxonomy_detail;
	// 	}
	// 	return '';
	// };

	const invoiceableDates = [];
	for (let i = 0; i < 12; i++) {
		invoiceableDates.push(sub(startOfMonth(new Date()), { months: i }));
	}
	return (
		<>
			<div className="breadcrumbs">
				<ul>
					<li>
						<Link to="/" className="link">
							Home
						</Link>
					</li>
					<li>
						<Link to="/ilos-panel" className="link">
							Billing
						</Link>
					</li>
					<li>Invoicing</li>
				</ul>
			</div>
			<div className="clear-both px-4 py-4 mt-2 bg-white rounded-lg">
				<h2>Invoicing</h2>
				<div className="divider" />
				<div className="grid grid-cols-3 gap-4">
					<div>
						<NavButton
							back
							title="Previous Month"
							onClick={handlePreviousMonth}
						/>
					</div>
					<div className="text-center">
						<select
							className="select select-sm select-bordered"
							onChange={({ target }) => setMonth(target.value)}
							value={month}
						>
							<option value="1">January</option>
							<option value="2">February</option>
							<option value="3">March</option>
							<option value="4">April</option>
							<option value="5">May</option>
							<option value="6">June</option>
							<option value="7">July</option>
							<option value="8">August</option>
							<option value="9">September</option>
							<option value="10">October</option>
							<option value="11">November</option>
							<option value="12">December</option>
						</select>
						<select
							className="ml-2 select select-sm select-bordered"
							onChange={({ target }) => setYear(target.value)}
							value={year}
						>
							{Array.from({ length: 5 }, (_, i) => (
								<option key={i} value={CURR_YEAR - 2 + i}>
									{CURR_YEAR - 2 + i}
								</option>
							))}
						</select>
					</div>
					<div className="text-right">
						<NavButton title="Next Month" onClick={handleNextMonth} />
					</div>
				</div>
				<table className="table mt-4 table-xs">
					<thead>
						<tr>
							<th>Scheduled Date</th>
							<th>Service</th>
							<th>Last, First</th>
							<th>DOB</th>
							<th>SKU</th>
							<th>Frequency</th>
							<th>Reimbursement Amount</th>
							<th>Fulfilled Date</th>
							<th>Fulfillment Status</th>
							<th>Fulfill?</th>
						</tr>
					</thead>
					<tbody>
						{lineItemsQuery.isFetching && (
							<tr>
								<td colSpan={10}>
									<span className="loading loading-spinner loading-xs"></span>
								</td>
							</tr>
						)}
						{lineItemsQuery?.data?.length === 0 && (
							<tr>
								<td colSpan={10}>No referrals found</td>
							</tr>
						)}
						{lineItemsQuery?.data?.map((item) => (
							<tr key={`${item.id}`}>
								<td>{format(new Date(item.incurred_dttm), 'P')}</td>
								<td>{item.request.taxonomy_detail}</td>
								<td>
									{item.request.client.name_last},{' '}
									{item.request.client.name_first}
								</td>
								<td>{formatBirthDate(item.request.client.birth_dttm)}</td>
								<td>
									{item.ilos_authorized_service?.taxonomy_sku?.sku_number}{' '}
									{item.ilos_authorized_service?.taxonomy_sku?.label}
								</td>
								<td>
									{
										constants.durationUnits[
											item.ilos_authorized_service.duration_unit
										]
									}
								</td>
								<td>
									{USDollar.format(
										item.ilos_authorized_service.service_unit_cost,
									)}
								</td>
								<td>
									{!isEmpty(item.fulfilled_dttm) &&
										format(new Date(item.fulfilled_dttm), 'P')}
								</td>
								<td>
									{!isEmpty(item.fulfilled_status) &&
										constants.fulfillmentStatus[item.fulfilled_status]}
								</td>
								<td>
									{isEmpty(item.fulfilled_dttm) && (
										<details className="dropdown dropdown-end">
											<summary className="btn btn-sm btn-primary">
												Complete?
											</summary>
											<ul className="menu dropdown-content bg-base-100 rounded-box z-[1] w-52 p-2 shadow">
												<li>
													<a
														onClick={() =>
															lineItemMutation.mutate({
																...item,
																status: 'FULFILLED',
															})
														}
													>
														Fulfill
													</a>
												</li>
												<li
													onClick={() =>
														lineItemMutation.mutate({
															...item,
															status: 'NOT_REIMBURSEABLE',
														})
													}
												>
													<a>Not Reimbursable</a>
												</li>
												<li
													onClick={() =>
														lineItemMutation.mutate({
															...item,
															status: 'NOT_ELIGIBLE',
														})
													}
												>
													<a>Not Eligible</a>
												</li>
											</ul>
										</details>
									)}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</>
	);
};

export default Invoicing;
